import constants from '@/constant'

const currentPresenterLanguage = (state) => {
  const locale = window.localStorage.getItem('ahaslides-presenter-language')
  if (locale) return locale
  const { personalInformation } = state.currentUser
  if (personalInformation &&
    personalInformation.presenterLanguage) return personalInformation.presenterLanguage
  return constants.presenterLanguage.en
}

const currentUserIsTeamOwnerOrAdmin = (state) => {
  return state.currentUser.accountId && (
    state.currentUser.accountRole === constants.workspace.OWNER ||
      state.currentUser.accountRole === constants.workspace.ADMIN
  )
}

export default {
  currentPresenterLanguage,
  currentUserIsTeamOwnerOrAdmin,
}
